"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SimplicityDataProviderImpl = void 0;
const FingerprintJS = __importStar(require("@fingerprintjs/fingerprintjs-pro"));
class SimplicityDataProviderImpl {
    constructor(options) {
        var _a;
        this.options = options;
        this.fingerprintEnabled = ((_a = this.options) === null || _a === void 0 ? void 0 : _a.useFingerprint) || false;
        if (!(options === null || options === void 0 ? void 0 : options.lazyInitialize) && typeof window !== 'undefined') {
            this.initSimplicityPromise = this.loadSimplicity();
        }
    }
    loadSimplicity() {
        return new Promise(resolve => {
            var _a, _b;
            // Simplicity will call onSimplicityDataAvailable when it has completed.
            window.onSimplicityDataAvailable = (data) => {
                if (this.fingerprintEnabled) {
                    this.loadFingerprint();
                }
                resolve(data);
            };
            // Check if the simplicity script has already been added as a script element.
            const scripts = document.getElementsByTagName('script');
            let loaded = false;
            let scriptUrl = ((_a = this.options) === null || _a === void 0 ? void 0 : _a.simplicityScriptUrl) || 'https://simplicity.trustpilot.com/simplicity.js';
            for (let i = 0; i < scripts.length; i++) {
                if (scripts[i].src === scriptUrl) {
                    loaded = true;
                }
            }
            // Avoid loading Simplicity twice on the same page.
            if (loaded === false) {
                const sjs = document.getElementsByTagName('script')[0];
                const js = document.createElement('script');
                js.src = ((_b = this.options) === null || _b === void 0 ? void 0 : _b.simplicityScriptUrl) || 'https://simplicity.trustpilot.com/simplicity.js';
                js.onerror = event => {
                    var _a;
                    if ((_a = this.options) === null || _a === void 0 ? void 0 : _a.onError) {
                        this.options.onError(event);
                    }
                    resolve('');
                };
                if (sjs && sjs.parentNode) {
                    sjs.parentNode.insertBefore(js, sjs);
                }
            }
        });
    }
    getSimplicity(timeoutMs = 5000) {
        return __awaiter(this, void 0, void 0, function* () {
            let simplicityCompleted = false;
            if (!this.initSimplicityPromise) {
                this.initSimplicityPromise = this.loadSimplicity();
            }
            const startTime = Date.now();
            return Promise.race([
                this.initSimplicityPromise,
                new Promise(resolve => {
                    setTimeout(() => {
                        var _a;
                        if (!simplicityCompleted) {
                            if ((_a = this.options) === null || _a === void 0 ? void 0 : _a.onTimeout) {
                                this.options.onTimeout(Date.now() - startTime);
                            }
                            resolve('');
                        }
                    }, Math.max(0, timeoutMs));
                }),
            ]).finally(() => {
                simplicityCompleted = true;
            });
        });
    }
    loadFingerprint() {
        this.initFingerprintPromise = new Promise(resolve => {
            return FingerprintJS.load({
                region: 'eu',
                scriptUrlPattern: [
                    "https://fp-prx.trustpilot.com/gZcjjCCkyc7DCVJLywfD/szRz2YviSTyJDNV2mNP7?apiKey=<apiKey>&version=<version>&loaderVersion=<loaderVersion>",
                    FingerprintJS.defaultScriptUrlPattern, // Use default script URL pattern as a fallback.
                ],
                endpoint: [
                    'https://fp-prx.trustpilot.com/gZcjjCCkyc7DCVJLywfD/2g9FcYZzrQkzcZ4tVXk7?region=eu',
                    FingerprintJS.defaultEndpoint // Use default endpoint as a fallback.
                ],
                apiKey: '4bhpfCxkCrdBIJkus95S',
            })
                .then(fpAgent => resolve(fpAgent))
                .catch(error => {
                var _a;
                if ((_a = this.options) === null || _a === void 0 ? void 0 : _a.onError) {
                    this.options.onError('Error loading fingerprint agent', error);
                }
                resolve(undefined);
            });
        });
    }
    getFingerprint(timeoutMs = 5000) {
        return __awaiter(this, void 0, void 0, function* () {
            let fingerprintCompleted = false;
            try {
                const savedFingerprint = sessionStorage.getItem('TP.fp') || '';
                if (savedFingerprint && savedFingerprint !== '') {
                    fingerprintCompleted = true;
                    return savedFingerprint;
                }
            }
            catch (e) { }
            if (!this.initFingerprintPromise) {
                this.loadFingerprint();
            }
            const startTime = Date.now();
            const fpPromise = new Promise(resolve => {
                var _a;
                (_a = this.initFingerprintPromise) === null || _a === void 0 ? void 0 : _a.then(fpAgent => {
                    if (!fpAgent || fpAgent === undefined) {
                        return resolve('');
                    }
                    fpAgent
                        .get({ timeout: timeoutMs })
                        .then(result => {
                        sessionStorage.setItem('TP.fp', JSON.stringify(result));
                        return resolve(JSON.stringify(result));
                    })
                        .catch(error => {
                        var _a;
                        if ((_a = this.options) === null || _a === void 0 ? void 0 : _a.onError) {
                            this.options.onError('Error getting fingerprint', error);
                        }
                        resolve('');
                    });
                }).catch(error => {
                    var _a;
                    if ((_a = this.options) === null || _a === void 0 ? void 0 : _a.onError) {
                        this.options.onError('Error loading fingerprint agent from unreachable catch', error);
                    }
                    resolve('');
                });
            });
            return Promise.race([
                fpPromise,
                new Promise(resolve => {
                    setTimeout(() => {
                        var _a;
                        if (!fingerprintCompleted) {
                            if ((_a = this.options) === null || _a === void 0 ? void 0 : _a.onTimeout) {
                                this.options.onTimeout(Date.now() - startTime);
                            }
                            resolve('');
                        }
                    }, Math.max(0, timeoutMs));
                }),
            ]).finally(() => {
                fingerprintCompleted = true;
            });
        });
    }
    getSimplicityData(timeoutMs = 5000) {
        var _a, _b, _c, _d;
        return __awaiter(this, void 0, void 0, function* () {
            if (!this.fingerprintEnabled) {
                return yield this.getSimplicity(timeoutMs);
            }
            let simplicityResult = '';
            let simplicityData = {};
            try {
                simplicityResult = yield this.getSimplicity(timeoutMs);
                simplicityData = !simplicityResult || simplicityResult === '' ? {} : JSON.parse(simplicityResult);
            }
            catch (error) {
                if ((_a = this.options) === null || _a === void 0 ? void 0 : _a.onError) {
                    this.options.onError('Error getting simplicity', error);
                }
            }
            // Fallback: Simplicity also saves its result to session storage.
            if (!simplicityResult || simplicityResult === '') {
                try {
                    const tpUm = sessionStorage.getItem('TP.um') || '';
                    simplicityData = !tpUm || tpUm === '' ? {} : JSON.parse(tpUm);
                }
                catch (error) {
                    if ((_b = this.options) === null || _b === void 0 ? void 0 : _b.onError) {
                        this.options.onError('Error reading tp.Um from session storage', error);
                    }
                }
            }
            let fingerprintResult;
            let fingerprintData = {};
            try {
                fingerprintResult = yield this.getFingerprint(timeoutMs);
                fingerprintData = !fingerprintResult || fingerprintResult === '' ? {} : JSON.parse(fingerprintResult);
            }
            catch (error) {
                if ((_c = this.options) === null || _c === void 0 ? void 0 : _c.onError) {
                    this.options.onError('Error getting fingerprint', error);
                }
            }
            try {
                const combined = Object.assign(Object.assign({}, simplicityData), { fingerprint: fingerprintData });
                return JSON.stringify(combined);
            }
            catch (error) {
                if ((_d = this.options) === null || _d === void 0 ? void 0 : _d.onError) {
                    this.options.onError('Error combining fingerprint', error);
                }
                return '';
            }
        });
    }
}
exports.SimplicityDataProviderImpl = SimplicityDataProviderImpl;
